import './App.scss';
import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Pages
// ----
import { Layout } from './pages/layout/layout';
import { Overview } from './pages/overview/overview';
import { BecomingAParticipant } from './pages/becoming-a-participant/becoming-a-participant';
import { ParticipantInformation } from './pages/participant-information/participant-information';
import { News } from './pages/news/news';
import { Sitemap } from './pages/sitemap/sitemap';
import { ContactUs } from './pages/contact-us/contact-us';
import { Disclaimers } from './pages/disclaimers/disclaimers';
import { DownloadPage } from './pages/download-page/download-page';
import { TermsOfUse } from './pages/terms-of-use/terms-of-use';

// Subpages
// ---------------------

// News
import { MarketAlerts } from './pages/news/subpages/market-alerts/market-alerts';
import { SecuritiesUpdates } from './pages/news/subpages/securities-updates/securities-updates';
import { SecuritiesSuspensions } from './pages/news/subpages/securities-suspensions/securities-suspensions';
import { NewsAndUpdates } from './pages/news/subpages/news-and-updates/news-and-updates';

//helper
import { getPath } from './assets/scripts/helpers';

// Google Analytics 
import TagManager from "react-gtm-module";

TagManager.initialize({
  gtmId: window.MD?.GTM_ID || "",
  auth: window.MD?.GTM_AUTH || "",
  preview: window.MD?.GTM_PREVIEW || "",
});

const legacyPath = {
  becomingaparticipant: 'becoming-a-participant',
  infoparticipantsaep: 'participant-information',
  newsupdates: 'news/news-and-updates',
  'newsupdates?archive=1': 'news/news-and-updates?archive=1',
  marketalerts: 'news/market-alerts',
  'marketalerts?archive=1': 'news/market-alerts?archive=1',
  securitiesupdates: 'news/securities-updates',
  securitiessuspensions: 'news/securities-suspensions',
  historicsecuritiessuspensions: 'news/securities-suspensions?historic=1',
  contactus: 'contact',
  termsofuse: 'terms-of-use'
};

function App() {
  const path = getPath();
  const childPath = path.substring(path.indexOf('/') + 1).toLowerCase();
  const param = window.location.search.substring(0);
  const [isLegacyPath, setIsLegacyPath] = useState(
    legacyPath[childPath] ? true : false
  );

  const changeLegacyPath = () => {
    window.history.replaceState(
      {},
      legacyPath[childPath],
      '/sigmaxmtf/' + legacyPath[childPath] + param
    );
    setIsLegacyPath(false);
  };

  return (
    <div className='App'>
      {isLegacyPath ? (
        changeLegacyPath()
      ) : (
        <BrowserRouter>
          <Routes>
            <Route path='sigmaxmtf' element={<Layout />}>
              <Route index element={<Overview />} />
              <Route index path='overview' element={<Overview />} />
              <Route
                path='becoming-a-participant'
                element={<BecomingAParticipant />}
              />
              <Route
                path='participant-information'
                element={<ParticipantInformation />}
              />
              <Route path='news' element={<News />}>
                <Route
                  index
                  path='news-and-updates'
                  element={<NewsAndUpdates />}
                />
                <Route path='market-alerts' element={<MarketAlerts />} />
                <Route
                  path='securities-updates'
                  element={<SecuritiesUpdates />}
                />
                <Route
                  path='securities-suspensions'
                  element={<SecuritiesSuspensions />}
                />
                <Route path='' element={<Navigate to='news-and-updates' />} />
              </Route>
              <Route path='contact' element={<ContactUs />} />
              <Route path='disclaimers' element={<Disclaimers />} />
              <Route path='terms-of-use' element={<TermsOfUse />} />
              <Route path='sitemap' element={<Sitemap />} />
              {/* Download Paths */}
              <Route path='downloadDocuments' element={<DownloadPage />} />
              {/* <Route
              path="TickSizeTableDownloadAEP"
              element={
                <DownloadPage
                  downloadType={''}
                  feedId={''}
                  docTag={''}
                  componentType={''}
                  fileName={''}
                />
              }
            /> */}

              <Route path='*' element={<Navigate to='overview' />} />
            </Route>
          </Routes>
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
